//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'index',
  props: {
    videoUrl: {
      type: String,
      required: true,
      default: '',
      desc: '视频地址'
    },
    showState: {
      type: Boolean,
      required: true,
      default: false,
      desc: '视频播放弹层显示'
    }
  },
  data () {
    return {}
  },
  computed: {
    show () {
      return this.showState
    }
  },
  methods: {
    videoStop () {
      this.$refs.video.pause()
      this.$parent.videoShow = false
    },
    videoPlay () {
      this.$parent.videoShow = true
      this.$refs.video.play()
    },
  }
}
